import axios from "axios";

export default {
  namespaced: true,
  state: {
    members: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    membersMessage: ''
  },
  mutations: {
    CLEAR_MARKETMEMBERS(state) {
      state.members = [];
    },
    RECEIVED_MARKETMEMBERS(state, payload) {
      state.members = payload;
      state.isReceiving = false;
    },
    RECEIVING_MARKETMEMBERS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MARKETMEMBER(state, payload) {
      state = Object.assign(state, {
        members: [...state.members, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MARKETMEMBER(state) {
      state.isReceiving = true;
    },
    UPDATED_MARKETMEMBER(state, payload) {
      let index = state.members.findIndex(member => member._id === payload._id);
      state = Object.assign(state, {
        members: state.members.map((member, i) => {
          if (i === index) {
            return Object.assign({}, member, payload);
          }
          return member;
        }),
        isUpdating: false,
        membersMessage: 'MarketMembers has been updating!',
      })
    },
    UPDATING_MARKETMEMBER(state) {
      state.isUpdating = true;
    },
    DELETED_MARKETMEMBER(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.members.findIndex(member => member._id === payload._id);
      console.log(indexToDelete);
      let members = [...state.members];
      members.splice(indexToDelete, 1);
      state = Object.assign(state, {
        members: [...members],
        isDeleting: false,
        idToDelete: null,
        membersMessage: 'MarketMember has been Deleted!',
      });
    },
    DELETING_MARKETMEMBER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteMarketMemberRequest({dispatch}, payload) {
      dispatch("deletingMarketMember", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/marketmember/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        console.log(response.data);
        dispatch("deleteMarketMember", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteProjectMemberRequest({dispatch}, payload) {
      try{
        dispatch("deletingMarketMember", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/marketmember/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMarketMember", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectMemberRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingMarketMember");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/marketmember/' + payload.projectid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMarketMembersRequest({dispatch}) {
      dispatch("receivingMarketMembers");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/get/marketmembers';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log(response.data);
        dispatch("receiveMarketMembers", response.data);
      })
    },
    async findMarketMembersRequest({dispatch}, payload) {
      dispatch("receivingMarketMembers");
      let token = localStorage.getItem('token');
      console.log(payload)
      let url = 'https://api.tradexc.com:3000/find/marketmembers';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "POST", url: url, headers: header, data: payload})
      .then(response => {
        dispatch("receiveMarketMembers", response.data);
      })
    },
    async updateMarketMemberRequest({dispatch}, payload) {
      dispatch("updatingMarketMember");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/marketmember/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateMarketMember", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateProjectMemberRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketMember");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketmember/' + payload.memberid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketMember", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    clearMarketMembers({commit}) {
      commit("CLEAR_MARKETMEMBERS")
    },
    receiveMarketMembers({commit}, payload) {
      commit("RECEIVED_MARKETMEMBERS", payload)
    },
    receivingMarketMembers({commit}) {
      commit("RECEIVING_MARKETMEMBERS")
    },
    receiveMarketMember({commit}, payload) {
      commit("RECEIVED_MARKETMEMBER", payload)
    },
    receivingMarketMember({commit}) {
      commit("RECEIVING_MARKETMEMBER")
    },
    updateMarketMember({commit}, payload) {
      commit("UPDATED_MARKETMEMBER", payload)
    },
    updatingMarketMember({commit}) {
      commit("UPDATING_MARKETMEMBER")
    },
    deleteMarketMember({commit}, payload) {
      commit("DELETED_MARKETMEMBER", payload)
    },
    deletingMarketMember({commit}, payload) {
      commit("DELETING_MARKETMEMBER", payload)
    }
  },
};
